import { render } from "./picsPart.vue?vue&type=template&id=259425aa&scoped=true"
import script from "./picsPart.vue?vue&type=script&lang=js"
export * from "./picsPart.vue?vue&type=script&lang=js"

import "./picsPart.vue?vue&type=style&index=0&id=259425aa&scoped=true&lang=less"

import exportComponent from "/root/drive/src/landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-259425aa"]])

export default __exports__